import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import McpDefaultAgreement from './McpDefaultAgreement';
import McpSourceSystems from './McpSourceSystems';
import '../Admin.css';
import './McpServicePage.css';

// ADMIN › PLATFORM › MCP AS A SERVICE — /admin/mcp-service. hconnect's platform-wide side of the product, for
// superadmins: the PMS systems it supports as sources (McpSourceSystems), and the default agreement with the hotel
// proposals waiting for approval (McpDefaultAgreement). The chains'
// and hotels' own settings stay on MCP as a Service (/mcp-service) and Chain Settings › MCP. Like every Admin screen it
// ignores the chain and hotel chosen in the navbar.
//
// Three tabs, the tab in the URL (?tab=) as on the MCP hotel page: Supported PMS systems, Proposals (the hotels' own
// agreements waiting for approval), Default agreement.

const TABS = [['systems', 'Supported PMS systems'], ['proposals', 'Proposals'], ['default', 'Default agreement']];

export default function McpAdminPage() {
  const { isSuperAdmin } = useAuth();
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = TABS.some(([k]) => k === searchParams.get('tab')) ? searchParams.get('tab') : 'systems';
  const setTab = (k) => setSearchParams((prev) => { const p = new URLSearchParams(prev); p.set('tab', k); return p; }, { replace: true });
  return (
    <div className="admin-container">
      <div className="admin-header">
        <h2>MCP as a Service</h2>
      </div>
      <p style={{ color: '#6b7280', marginTop: '-0.5rem', marginBottom: '1rem' }}>
        hconnect&rsquo;s side of the service: the PMS systems it supports, and the service agreement every hotel must accept
        before AI assistants can use it. Chains and hotels manage their own settings under MCP as a Service.
      </p>
      {isSuperAdmin ? (
        <>
          <div className="mcps-tabs">
            {TABS.map(([k, label]) => (
              <button key={k} type="button" className={`mcps-tab ${tab === k ? 'active' : ''}`} onClick={() => setTab(k)}>{label}</button>
            ))}
          </div>
          {tab === 'systems' && <McpSourceSystems />}
          {tab === 'proposals' && <McpDefaultAgreement section="proposals" />}
          {tab === 'default' && <McpDefaultAgreement section="default" />}
        </>
      ) : <div className="error">Only superadmins can manage MCP as a Service for the platform.</div>}
    </div>
  );
}
